import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import request from '@/utils/request';
export function login(data) {
  return request({
    url: '/ysa-auth-service/login',
    method: 'post',
    datatype: 'json',
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded'
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify({
      username: data.username,
      password: data.password,
      code: data.code,
      codeKey: data.codeKey,
      type: data.type,
      tenantId: data.tenantId
    }),
    /*params: {
      username: data.username,
      password: data.password,
      code: data.code,
      codeKey: data.codeKey,
      type: data.type,
      tenantId: data.tenantId
    },*/
    withCredentials: true
  });
}
export function getInfo() {
  return request({
    url: '/ysa-system-service/system/permission/info',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}
// 联盟列表
export function queryUnionList(data) {
  return request({
    url: '/ysa-afterSale-service/after_sale/unionAfter/queryUnionList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}

// 修改密码
export function updatePwd(data) {
  return request({
    url: '/ysa-system-service/system/user/updatePwd',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}

// 获取code验证码
export function validateCodeImage(data) {
  return request({
    url: '/ysa-auth-service/login/validateCodeImage',
    method: 'get',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function logout(token) {
  return request({
    url: '/ysa-auth-service/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'token': token
    }
  });
}
export function UnifyLogout(token, url) {
  return request({
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'token': token
    }
  });
}
export function getTenantList(data) {
  return request({
    url: '/ysa-auth-service/getTenantList',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: data
  });
}
export function getTenantListByDomain(data) {
  return request({
    url: '/ysa-auth-service/getTenantListByDomain',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: data
  });
}

// 校验密码
export function validatePassword(data) {
  return request({
    url: '/ysa-auth-service/checkPasswordRule',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: data
  });
}

// 获取微信登录二维码
export function getWxCode(data, cancelToken) {
  return request(_objectSpread({
    url: '/ysa-auth-service/wx/mini/scan/create',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  }, cancelToken));
}

// 获取微信登录是否成功
export function getWxCodeResult(data, cancelToken) {
  return request(_objectSpread({
    url: '/ysa-auth-service/wx/mini/scan/poll',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  }, cancelToken));
}